export const AMENITY_URL = 'https://app.elevatedliving/mob/amenities';
